import {
  getGetNodoPortaleQueryKey,
  NodoDto,
  useActionDispositivo,
} from "@/api";
import { SmallLoading } from "@/components/Loading";
import Button from "@/elements/Button";
import { portaleConfig } from "@/portaliConfig";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { DispositivoAction } from "../..";

export function ResetOnlyButtons({ nodo }: { nodo: NodoDto }) {
  const { t } = useTranslation();
  const [sentAction, setSentAction] = useState<DispositivoAction | null>(null);

  const { mutateAsync: setActionAsync, isLoading: actionLoading } =
    useActionDispositivo();

  const queryClient = useQueryClient();

  async function setAction(action: DispositivoAction) {
    try {
      setSentAction(action);
      const response = await setActionAsync({
        id: nodo.id,
        data: { action: action },
      });
      if (response.data?.updated) {
        toast.success(t("dispositivoActions.toast.statoSuccess"));
      } else {
        toast.warn(t("dispositivoActions.toast.statoNoResponse"));
      }
    } catch (e) {
      toast.error(t("dispositivoActions.toast.statoError"));
    } finally {
      setSentAction(null);
      queryClient.invalidateQueries({
        queryKey: getGetNodoPortaleQueryKey(portaleConfig.id, nodo.id),
      });
    }
  }

  return (
    <>
      <Button
        size="small"
        variant="contained"
        color={actionLoading ? undefined : "light"}
        disabled={actionLoading}
        onClick={() => {
          setAction("reset").then();
        }}
        startIcon={sentAction === "reset" && <SmallLoading sx={{ mr: 1 }} />}
      >
        {t("azioni.reset")}
      </Button>
    </>
  );
}
